// AppRoutes.js
import React, { useState } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import NoAuthRoute from './NoAuthRoute';
import AdminRoute from "./AdminRoute";
import Login from "../pages/Login/Login";
import Logout from "../pages/Logout/Logout";
import HomePages from "../pages/HomePage/HomePage";
import LocalGamePages from "../pages/LocalGamePage/LocalGamePage";
import SoloBotPage from "../pages/SoloBotPage/SoloBotPage";
import SoloBotPageArg from "../pages/SoloBotPage/SoloBotPageArg";
import OnlineLobbyPage from "../pages/OnlineLobbyPage/OnlineLobbyPage";
import MatchmakingPage from "../pages/MatchmakingPage/MatchmakingPage";
import WaitingRoomPage from "../pages/WaitingRoomPage/WaitingRoomPage";
import OnlineGamePages from "../pages/OnlineGamePage/OnlineGamePage";
import PlayerFinderPage from "../pages/PlayerFinderPage/PlayerFinderPage";
import PlayerFinderPageArg from "../pages/PlayerFinderPage/PlayerFinderPageArg";
import RankingPage from "../pages/RankingPage/RankingPage";
import PoliticaPrivacidad from "../pages/PoliticaPrivacidad/PoliticaPrivacidad";
import AdminPage from "../pages/AdminPage/AdminPage";
import SquadPage from "../pages/SquadPage/SquadPage";
import SquadPageArg from "../pages/SquadPage/SquadPageArg";
import CountryGamePage from "../pages/CountryGamePage/CountryGamePage";
import PenaltyPage from "../pages/PenaltyPage/PenaltyPage";
import GuessPlayerPage from "../pages/GuessPlayerPage/GuessPlayerPage";
import ClubRacePage from "../pages/ClubRacePage/ClubRacePage";
import ClubRacePageArg from "../pages/ClubRacePage/ClubRacePageArg";
import CareerSimulatorPage from "../pages/CareerSimulatorPage/CareerSimulatorPage";
// Versión con Mundial + selecciones (en pruebas, ruta aparte para no tocar /career de los QA).
import CareerSimulatorPage2 from "../pages/CareerSimulatorPage2/CareerSimulatorPage2";
import DealPage from "../pages/DealPage/DealPage";
import TimeLimitContext from "../context/TimeLimitContext";
import CountryContext from "../context/CountryContext";
import StealCapContext from "../context/StealCapContext";

// Para reactivar el modo online en PC: cambiar a true
const ONLINE_ENABLED = false;

function AppRoutes() {
    const [timeLimit, setTimeLimit] = useState(60)
    const [numberOfCountries, setNumberOfCountries] = useState("top");
    const [stealCap, setStealCap] = useState(3);

    return (
        <TimeLimitContext.Provider value={{ timeLimit, setTimeLimit }} >
            <StealCapContext.Provider value={{ stealCap, setStealCap }}>
            <CountryContext.Provider value={{ numberOfCountries, setNumberOfCountries }}>
                <Router>
                    <Routes>
                        <Route path="/" element={<HomePages />} />
                        <Route path="/login" element={<NoAuthRoute><Login /></NoAuthRoute>} />
                        <Route path="/register" element={<NoAuthRoute><Login /></NoAuthRoute>} />
                        <Route path="/logout" element={<Logout />} />
                        <Route path="/local" element={<LocalGamePages />} />

                        {/* Online system */}
                        <Route path="/room" element={ONLINE_ENABLED ? <OnlineLobbyPage /> : <Navigate to="/" replace />} />
                        <Route path="/matchmaking" element={ONLINE_ENABLED ? <MatchmakingPage /> : <Navigate to="/" replace />} />
                        <Route path="/waiting-room/:roomCode" element={ONLINE_ENABLED ? <WaitingRoomPage /> : <Navigate to="/" replace />} />
                        <Route path="/room/:urlRoomCode" element={ONLINE_ENABLED ? <OnlineGamePages /> : <Navigate to="/" replace />} />

                        <Route path="/deal" element={<DealPage />} />
                        <Route path="/player-finder" element={<PlayerFinderPage />} />
                        <Route path="/player-finder-arg" element={<PlayerFinderPageArg />} />
                        <Route path="/solo-bot" element={<SoloBotPage />} />
                        <Route path="/solo-bot-arg" element={<SoloBotPageArg />} />
                        <Route path="/squad" element={<SquadPage />} />
                        <Route path="/squad-arg" element={<SquadPageArg />} />
                        <Route path="/roster" element={<CountryGamePage />} />
                        <Route path="/penalty" element={<PenaltyPage />} />
                        <Route path="/guess-player" element={<GuessPlayerPage />} />
                        <Route path="/club-race" element={<ClubRacePage />} />
                        <Route path="/club-race-arg" element={<ClubRacePageArg />} />
                        <Route path="/career" element={<CareerSimulatorPage />} />
                        <Route path="/career2" element={<CareerSimulatorPage2 />} />
                        <Route path="/ranking" element={<RankingPage />} />
                        <Route path="/privacy-policy" element={<PoliticaPrivacidad />} />
                        <Route path="/admin" element={<AdminRoute><AdminPage /></AdminRoute>} />
                        <Route path="*" element={<HomePages />} />
                    </Routes>
                    <ToastContainer />
                </Router>
            </CountryContext.Provider>
            </StealCapContext.Provider>
        </TimeLimitContext.Provider>
    );
}

export default AppRoutes;


